import { LoadingButton } from '@mui/lab';
import BasicModal from '../../common/BasicModal';
import { Box, Button, TextField } from '@mui/material';
import IosSwitch from '../../common/IosSwitch';
import { useTranslation } from 'react-i18next';
import { Dispatch, FC, SetStateAction } from 'react';

type Props = {
	checked: boolean;
	title: string;
	label: string;
	openModal: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	setChecked: Dispatch<SetStateAction<boolean>>;
	setTitle: Dispatch<SetStateAction<string>>;
	handleCreate: () => void;
};

const CategoryModal: FC<Props> = ({ openModal, setOpen, title, checked, label, handleCreate, setTitle, setChecked }) => {
	let { t } = useTranslation();
	const handleOpenModal = () => {
		setOpen(!openModal);
		setTitle('');
		setChecked(false);
	};

	return (
		<BasicModal
			open={!!openModal}
			onClose={handleOpenModal}
			title={t(label)}
			titleClassName={'text-center grow '}
			subClassName={'flex flex-row-reverse'}
			className={'max-w-xl rounded-lg'}
			showBackIcon={false}
			action={
				<div className="w-full">
					<LoadingButton onClick={handleCreate} variant="contained" color="primary" className="mx-2">
						{t('register')}
					</LoadingButton>
					<Button onClick={handleOpenModal} variant="outlined" className="mx-2" color="error">
						{t('cancel')}
					</Button>
				</div>
			}
		>
			<Box className="mb-3 mt-6 flex flex-col">
				<TextField onChange={e => setTitle(e.target.value)} value={title} className="mb-2" label={t(label)} />
				<IosSwitch checked={checked} setValue={setChecked} color="primary" label={t('status_action')} />
			</Box>
		</BasicModal>
	);
};

export default CategoryModal;
